import React from 'react';
import { SupplyShedDriveTime } from '../../lib/types';

interface SupplyShedToggleProps {
  selectedDriveTime: SupplyShedDriveTime;
  onDriveTimeChange: (time: SupplyShedDriveTime) => void;
  isLoading?: boolean;
}

const DRIVE_TIMES: SupplyShedDriveTime[] = [60, 90];

export const SupplyShedToggle: React.FC<SupplyShedToggleProps> = ({
  selectedDriveTime,
  onDriveTimeChange,
  isLoading,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-body font-roboto font-medium text-figma-text">
        Supply shed (drive time)
      </label>
      <div className="flex items-center gap-3">
        <div className="inline-flex rounded-[10px] overflow-hidden border border-figma-mint">
          {DRIVE_TIMES.map((time) => {
            const active = selectedDriveTime === time;
            return (
              <button
                key={time}
                onClick={() => onDriveTimeChange(time)}
                className={`px-3.5 py-2 text-[13px] font-roboto-mono font-medium whitespace-nowrap transition-colors ${
                  active
                    ? 'bg-figma-mint text-[#070807]'
                    : 'bg-transparent text-figma-text hover:bg-figma-mint/10'
                }`}
              >
                {time} min
              </button>
            );
          })}
        </div>

        {/* Loading indicator */}
        {isLoading && (
          <div className="w-4 h-4 border-2 border-figma-mint/30 border-t-figma-mint rounded-full animate-spin" />
        )}
      </div>
    </div>
  );
};
